var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("AdminInventorySubMenusLinks", {
    attrs: {
      loggedUserData: _vm.loggedUserData,
      forceTab: "items",
      isExternal: true
    }
  }), _c("div", {
    staticClass: "content-centered large"
  }, [_c("stock", {
    attrs: {
      idStock: _vm.id_stock,
      listCountries: _vm.countries,
      loggedUserData: _vm.loggedUserData,
      mode: "page"
    }
  })], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };